export default __webpack_public_path__ + "static/media/Group_chat.048b8b8b.svg";